import React, { Component, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, QuickUploader, Action, AlertD, ModalCustom, ActionButton, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState } from '../.././Componet';
import { useParams } from "react-router-dom";
import { Route,Link } from "react-router-dom";
import { Modal } from 'bootstrap';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'
import { data } from 'jquery';
class CategoryMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Category", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.Categorys);
        h.Ajax('Category', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <ProTable datasourcename='Categorys' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <Column metaForDisplay={DataClass.PostCategory.Id} />
                    <Column metaForInput={DataClass.PostCategory.Title} />

                </ProTable>

            </FromSubmit>

        }

    }


}

class SlideShowMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Records: [] };
        this.submit = this.submit.bind(this);
        this.SlideShows = [];
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("SlideShow", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });
            cmd.SlideShows = datas;
        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.SlideShows);
        h.Ajax('SlideShow', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <QuickUploader mulitFile={true} justImage={true} onUpload={(urls) => {
                    let data = [...window.SlideShows];
                    for (let i = 0; i < urls.length; i++) {
                        data.push({ imageUrl: urls[i], rowState: RowState.Inserted });
                    }
                    this.setState({ isLoaded: true, Records: data });
                    window.SlideShows = data;
                }} ></QuickUploader>
                <ProTable datasourcename='SlideShows' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    
                    <Column metaForInput={DataClass.SlideShow.Title} />
                    <Column columnName='imageUrl' caption='تصویر' type={ColumnType.InputImage} />
                    <Column metaForInput={DataClass.SlideShow.Url} />

                </ProTable>

            </FromSubmit>

        }

    }


}

  export class PersonMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Person', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Person', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle='تعریف اعضای سازمان'>
                <AddButton title='' entity='Person' /> <ProTable Records={this.state.Records} datasourcename='Persons'>
                    <Column metaForDisplay={DataClass.Person.Id} />
                    <Column metaForDisplay={DataClass.Person.Name} />
                    <Column metaForDisplay={DataClass.Person.Position} />
                    <Column columnName='imageUrl' type={ColumnType.Image} caption="تصویر" />

                    <Action Icon="Edit" caption="ویرایش" type="Link" pageName="/Person/Edit" columnName="id" />


                    <Action Icon="Delete" caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


/* دریافت تمامی رکورد ها */
  



/* ویرایش */
function EditPerson() {
    const queryS = useParams();
    return <AddPerson id={queryS.id} />
}
function Links() {
    const queryS = useParams();
    return <LinkMgt parentId={queryS.parentId} linkPosition={queryS.linkPosition} key={queryS.parentId} />
}

function LinkWizard() {
    return <FromBasic>
        کدام قسمت را می خواهید را ویرایش کنید

        <br />
        <div  >
        {enums.LinkPosition.map((v) => {
            return <Link style={{ width: '100%', display: 'block' }} to={"/Admin/Links/" + v.value + "/0"}><SimpleButton style={{ width: '100%' }} title={v.caption}></SimpleButton></Link>
        })}
        </div>

    </FromBasic>



}



/* درج و و یرایش رکورد */


export class AddPerson extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Person', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('Person', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
            
            <InputBox meta={DataClass.Person.Name} size='50%' />
            <InputBox meta={DataClass.Person.Position} size='50%' />
            <InputBox meta={DataClass.Person.ImageUrl} customHelper={CustomHelper.Image} size='50%' />


        </FromSubmit>

    }

}
export class PostMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
         
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Post', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Post', 'Serach', h.GetPostData(), function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
     
        return <FromBasic staticTitle='مدیریت مطالب'>
            <InputTextBox caption="از تاریخ" customHelper={CustomHelper.isDate} size="50%" columnName="start" model="start"/ >
            <InputTextBox caption="تا تاریخ" customHelper={CustomHelper.isDate} size="50%" columnName="to" model="to" />
            <InputTextBox caption="عنوان" size="50%" columnName="title" model="title" />
          
                <DropDownBox caption="دسته" columnName="catId" entity="Category" includeAll={true} size="50%" />

               
            
            <center>
                <SimpleButton title="نمایش" onClick={() => { this.Refersh() }} />
            </center>
            {this.props.onSelected == undefined && <AddButton title='' entity='Post' />}
             <ProTable Records={this.state.Records} datasourcename='Posts'>
                  
                    <Column metaForDisplay={DataClass.Post.Title} />

                <Column columnName='catName' caption="دسته" type={ColumnType.DisplayValue} />

                    <Column columnName='imageUrl'   caption="تصویر" type={ColumnType.Image} />
                   
                    <Column metaForDisplay={DataClass.Post.CreateTime} />
                   
                    <Column metaForDisplay={DataClass.Post.Status} />
                {this.props.onSelected == undefined  &&
                    <Action Icon="Edit" caption="ویرایش" type="Link" pageName="/Post/Edit" columnName="id" />
                    }
                {this.props.onSelected == undefined &&
                    <Action Icon="Delete" caption="حذف" type="function" targetFun={this.Delete} />
                }
                {this.props.onSelected != undefined &&
                    <Action Icon="Yes" caption="انتخاب" type="function" targetFun={this.props.onSelected} />
                }


            </ProTable>
           
            </FromBasic>
        
    }



}


/* دریافت تمامی رکورد ها */
  



/* ویرایش */
function EditPost() {
    const queryS = useParams();
    return <AddPost id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddPost extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('Post', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('Post', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
 
            <InputBox meta={DataClass.Post.Title} size='50%' />
            <InputBox meta={DataClass.Post.CatId} size='50%'  />
            <InputBox meta={DataClass.Post.SubTitle} customHelper={CustomHelper.LongText} size='100%' />
            <InputTextBox size='50%' model="imageUrl" initvalue="imageUrl" columnName='imageUrl' model='imageUrl' customHelper={CustomHelper.Image} caption="تصویر" mustFill="yes" />



            <InputBox meta={DataClass.Post.Status} size='50%' />
            <InputBox meta={DataClass.Post.Keywords} size='100%' />
            <InputTextBox size='100%' columnName='context' initvalue="context" model='context' customHelper={CustomHelper.Html} />
        
   


        </FromSubmit>

    }

}


export class AddSpecContext extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('SpecContext',  'Save', { Model: o   }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
       
            h.Ajax('SpecContext', 'Get', {  }, function (data) {
                h.SetDataBack(data);
            });


       
    }
    render() {
        return <FromSubmit submitBev={this.submit}>

            <InputBox meta={DataClass.SpecContext.AboutUs} size='100%' customHelper={CustomHelper.Html} />
            <InputBox meta={DataClass.SpecContext.Rules} size='100%' customHelper={CustomHelper.Html} />
            <InputBox meta={DataClass.SpecContext.ContactUs} size='100%' customHelper={CustomHelper.Html} />


        </FromSubmit>

    }

}

export class GalleryMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('Gallery', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Gallery', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='Gallery' /> <ProTable Records={this.state.Records} datasourcename='Gallerys'>
                    <Column metaForDisplay={DataClass.Gallery.Id} />
                    <Column metaForDisplay={DataClass.Gallery.Title} />
                    <Column metaForDisplay={DataClass.Gallery.Items} />

                    <Action Icon="Edit" caption="ویرایش" type="Link" pageName="/Gallery/Edit" columnName="id" />


                    <Action Icon="Delete" caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


/* دریافت تمامی رکورد ها */
  


/* ویرایش */
function EditGallery() {
    const queryS = useParams();
    return <AddGallery id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddGallery extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
        this.state = { isLoaded: false, Record: [] };
         
        window['GalleryItems'] = [];
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        o.items = [];
        for (let i = 0; i < window.GalleryItems.length; i++) {
            if (window.GalleryItems.rowState != RowState.Deleted) {
                o.items.push(window.GalleryItems[i]);
            }
           
        }
        h.Ajax('Gallery', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        if (this.id != -1) {
            h.Ajax('Gallery', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
                cmd.setState({ isLoaded: true, Record: data.items });
                window['GalleryItems'] = data.items;
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
           
            <InputBox meta={DataClass.Gallery.Title} size='100%' />
            <InputBox meta={DataClass.Gallery.SubTitle} customHelper={CustomHelper.LongText} size='100%' />
            <QuickUploader mulitFile={true} justImage={true} onUpload={(urls) => {
                let data = [...window.GalleryItems];
                for (let i = 0; i < urls.length; i++) {
                    data.push({ imageUrl: urls[i] });
                }
                this.setState({ isLoaded: true, Record: data });
                window.GalleryItems = data;
            }} ></QuickUploader>
            <ProTable datasourcename='GalleryItems' Records={this.state.Record} Insertable={true} Deleteable={true}>

                <Column columnName="id" type={ColumnType.DisplayValue} caption="شناسه" />
                <Column columnName="imageUrl" type={ColumnType.InputImage} caption="تصویر" />
                <Column columnName="link" type={ColumnType.InputText} caption="لینک" />


            </ProTable>


        </FromSubmit>

    }

}
class CommentMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: true, Record: [] };
        this.submit = this.submit.bind(this);
        this.serach = this.serach.bind(this);
        window.CommentSerachResults = [];
        this.setSelectedToTargetStatus = this.setSelectedToTargetStatus.bind(this);
    }
    componentDidMount() {
        this.serach();
    }
    serach() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Comment", "Search", hlp.GetPostData(), function (datas) {
            cmd.setState({ isLoaded: true, Record: datas });
            window.CommentSerachResults = datas;
        }, function () { });


    }
    setSelectedToTargetStatus(value) {
        let cmd = this;
        for (let i = 0; i < window.CommentSerachResults.length; i++) {
            if (window.CommentSerachResults[i].selected == true) {
                window.CommentSerachResults[i].status = value;
            }
           
        }
        cmd.setState({ isLoaded: true, Record: this.CommentSerachResults });
        window.CommentSerachResults = this.CommentSerachResults;
    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.CommentSerachResults);
        h.Ajax('Comment', 'SaveBatch', {  Updated: data[RowState.Changed] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                <InputTextBox caption="از تاریخ" customHelper={CustomHelper.isDate} size="50%" columnName="start" model="start" />
                <InputTextBox caption="تا تاریخ" customHelper={CustomHelper.isDate} size="50%" columnName="to" model="to" />
                <InputTextBox caption="عنوان شخص" size="50%" columnName="title" model="title" />
                <SelectBasic source={enums.CommentStatus} caption="وضعیت نظر" includeAll={true} columnName="status" size="50%" />
                <center>
                    <SimpleButton onClick={() => { this.serach(); }} title="جست و جو" />
                    <SimpleButton onClick={() => { this.setSelectedToTargetStatus(2); }} title="تایید" />
                    <SimpleButton onClick={() => { this.setSelectedToTargetStatus(3); }} title="عدم تایید" />

                </center>
                <ProTable datasourcename='CommentSerachResults' Records={this.state.Record}  >

                    <Column metaForDisplay={DataClass.CommentSerachResult.FullName} />
                     <Column metaForDisplay={DataClass.CommentSerachResult.Body} />
                    <Column metaForDisplay={DataClass.CommentSerachResult.PostTitle} />
                 
                    <Column metaForDisplay={DataClass.CommentSerachResult.Status} />
                    <Column metaForInput={DataClass.CommentSerachResult.AnswerMessage} />
                  
                    <Column columnName="selected" caption="انتخاب" type={ColumnType.InputCheck} />

                </ProTable>

            </FromSubmit>

        }

    }


}

export class MessageMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.ShowMessage = this.ShowMessage.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    ShowMessage(record) {
        let hlp = new Helper();
        let cmd = this;
      
            hlp.Ajax('Message', 'ShowMessage', { id:record.id }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(record.body, FixedMessage.Result);
            });
        
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('Message', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <ProTable Records={this.state.Records} datasourcename='Messages'>
                    <Column metaForDisplay={DataClass.Message.Id} />
                    <Column metaForDisplay={DataClass.Message.FullName} />
                    <Column metaForDisplay={DataClass.Message.MobileNo} />
                    <Column metaForDisplay={DataClass.Message.Email} />
       
                    <Column metaForDisplay={DataClass.Message.Status} />

                 
                    <Action Icon="View" caption="مشاهده" type="function" targetFun={this.ShowMessage} />




                </ProTable>
            </FromBasic>
        }
    }



}
class LinkMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.parentId = props.parentId;
        this.linkPosition = props.linkPosition;
        this.state = { isLoaded: false, Records: [] ,SpecLinks:[],title:'',filter:''};
        this.submit = this.submit.bind(this);
        this.loadLinks = this.loadLinks.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Link", "List", { parentId: this.parentId, linkPosition: this.linkPosition }, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas.list, title: datas.title, SpecLinks: [],  filter: '' });
            cmd.loadLinks();
            window.Links = cmd.state.Records;
        }, function () { });

    }
    loadLinks() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Link", "GetCustomLink", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: cmd.state.Records, SpecLinks: datas, title: cmd.state.title, filter:'' });

        }, function () { });
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.Links);
        h.Ajax('Link', 'SaveBatch', { linkPosition: this.linkPosition,Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted], parentId: this.parentId }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                window.location.reload();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
                پیوندهای {this.state.title} <br/>

                <ProTable datasourcename='Links'   Records={this.state.Records} Insertable={true}  >
                    <NewRecordValue columnName="order" newValue="0" />
                    <Column metaForInput={DataClass.Link.Title} />
                    <Column metaForInput={DataClass.Link.Url} />
                
                    <Column caption="تصویر" columnName="imageUrl" type={ColumnType.InputImage} />
                    <Column caption="اولویت" width="80px" columnName="order" type={ColumnType.InputFloat} />
                    <Column type={ColumnType.CustomElement} caption="عملیات" columnName="Id" customElement={(r) => {
                        if (this.state.SpecLinks == undefined) {
                            return <span>...</span>
                        }

                        return <ActionButton title="اقدام">
                            <input className="dropdown-item form-control" placeholder="جستجو..." filterMode style={{ border: '0.5px solid black' }}
                                onChange={(x) => {
                                    let s = this.state;
                                    s.filter = x.target.value;
                                    this.setState(s);
                                    
                                }}

                            ></input>
                            <a className="dropdown-item" onClick={() => {
                                $('#txtE').modal('show');
                                window.rowIndex = r;
                                $('#txtcatId').next('.select2-container').css('width', '500px');
                                $('#txtcatId').next('.dropdown-wrapper').css('width', '500px');
                            }} >جست و جوی پست</a>
                            <a className="dropdown-item" onClick={() => {
                                $('#txtCustomPage').modal('show');
                                window.rowIndex = r;
                              }} >جست و جوی صفحات خاص</a>
                            {r.id != undefined &&
                                <Link to={"/Admin/Links/" + this.linkPosition + "/" + r.id} className="dropdown-item">
                             زیر مجموعه این گره
                            </Link>
                            }
                            {r.id == undefined &&
                                <a onClick={() => {
                                    let h = new Helper();
                                    h.Alert('این گره ابتدا بایستی ذخیره شود ابتدا از دکمه تایید در بالا برای ذخیره استفاده کنید ');

                                }} className="dropdown-item">
                                    زیر مجموعه این گره
                                </a>
                            }
                            <a className="dropdown-item" onClick={() => {
                                window.Links_Delete(r);
                            }} >حذف </a>
                           
                            {this.state.SpecLinks.map((v) => {

                                if (this.state.filter != '') {
                                    if (v.title.indexOf(this.state.filter) == -1) {
                                        return null;
                                    }
                                }

                                return <a className="dropdown-item" onClick={() => {
                                    r.url = v.url;
                                    if (r.rowState == undefined) {
                                        r.rowState = RowState.Changed;
                                    }
                                    this.setState({ isLoaded: true, Records: this.state.Records, SpecLinks: this.state.SpecLinks });
                                }} >صفحه {v.title}</a>
                            })}
                        </ActionButton>
                    }} />
                    

                </ProTable>
                <ModalCustom id='txtE' title='انتخاب پست'>
                    <PostMgt onSelected={(v) => {
                        window.rowIndex.url = '/ShowPost/' +v.id;
                        this.setState({ isLoaded: true, Records: this.state.Records, SpecLinks: this.state.SpecLinks });

                        $('#txtE').modal('hide');
                    }} />
                </ModalCustom>
                <ModalCustom id='txtCustomPage' title='انتخاب صفحه خاص'>
                    <ProTable datasourcename="customLinks" Records={this.state.SpecLinks} >
                        <Column columnName="title" type={ColumnType.DisplayValue} caption="عنوان" />
                        <Column columnName="url" type={ColumnType.DisplayValue} caption="آدرس" />
                        <Column columnName="url" caption="عملیات" type={ColumnType.CustomElement} customElement={
                            (r) => {
                                return <SimpleButton Icon="Yes" title="انتخاب"
                                    onClick={() => {
                                        window.rowIndex.url = r.url;
                                        this.setState({ isLoaded: true, Records: this.state.Records, SpecLinks: this.state.SpecLinks });

                                        $('#txtCustomPage').modal('hide');

                                    }}                                ></SimpleButton>
                            }
                        }/>
                    </ProTable>
                </ModalCustom>
            </FromSubmit>

        }

    }


}

export class StaticPageMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('StaticPage', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('StaticPage', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='StaticPage' /> <ProTable Records={this.state.Records} datasourcename='StaticPages'>
                    <Column metaForDisplay={DataClass.StaticPage.Id} />
                    <Column metaForDisplay={DataClass.StaticPage.Name} />
                   
                    <Column metaForDisplay={DataClass.StaticPage.Keywords} />

                    <Action caption="ویرایش" type="Link" pageName="/StaticPage/Edit" columnName="id" />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}


/* دریافت تمامی رکورد ها */
  



/* ویرایش */
function EditStaticPage() {
    const queryS = useParams();
    return <AddStaticPage id={queryS.id} />
}

/* درج و و یرایش رکورد */


export class AddStaticPage extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('StaticPage', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('StaticPage', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
          
            <InputBox meta={DataClass.StaticPage.Name} size='100%' />
            <InputBox meta={DataClass.StaticPage.Context} size='100%' customHelper={CustomHelper.Html} />
            <InputBox meta={DataClass.StaticPage.Keywords} size='100%' />


        </FromSubmit>

    }

}



class LayoutMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { isLoaded: false, Record: [] };
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        let cmd = this;
        let hlp = new Helper();
        hlp.Ajax("Layout", "List", {}, function (datas) {
            cmd.setState({ isLoaded: true, Records: datas });

        }, function () { });

    }
    submit() {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetDataGrouped(window.Layouts);
        h.Ajax('Layout', 'SaveBatch', { Inserted: data[RowState.Inserted], Updated: data[RowState.Changed], deleted: data[RowState.Deleted] }
            , function (data) {
                h.MessageBox(FixedMessage.NoProblem, FixedMessage.Result);
                h.GoBack();
            },
        )
    }
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();
        }
        else {
            return <FromSubmit SubmitButtonOnTop={true} submitBev={this.submit} >
             
                <ProTable datasourcename='Layouts' Records={this.state.Records} Insertable={true} Deleteable={true}>
                    <NewRecordValue columnName="proptey" newValue={0}></NewRecordValue>
                    <Column metaForDisplay={DataClass.Layout.Id} />
                    <Column metaForInput={DataClass.Layout.LayoutSize} />
                    <Column metaForInput={DataClass.Layout.MobileLayoutSize} />
                    <Column caption="شی مورد " titleColumnName="layoutCaption" mustFill="yes" type={ColumnType.InputSelect2Ajax} entity="ObjectLayout" columnName="layoutObject" />
                    <Column caption={"تصویر"} columnName="imageUrl" type={ColumnType.InputImage} />
                    <Column metaForInput={DataClass.Layout.TargetLink} />
                    <Column metaForInput={DataClass.Layout.Proptey} />

                </ProTable>

            </FromSubmit>

        }

    }


}

export class TimeCounterMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });
        this.Delete = this.Delete.bind(this);
        this.Refersh = this.Refersh.bind(this);

    }

    Delete(record) {
        let hlp = new Helper();
        let cmd = this;
        hlp.ConfirmAction(FixedMessage.AreYouSure, '', function () {
            hlp.Ajax('TimeCounter', 'Delete', { Model: record }, function (data) {
                cmd.componentDidMount();
                hlp.MessageBox(data.message, FixedMessage.Result);
            });
        });
    }

    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('TimeCounter', 'List', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }

    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='TimeCounter' /> <ProTable Records={this.state.Records} datasourcename='TimeCounters'>
                    <Column metaForDisplay={DataClass.TimeCounter.Id} />
                    <Column metaForDisplay={DataClass.TimeCounter.Title} />
                    <Column metaForDisplay={DataClass.TimeCounter.SubTitle} />
                    <Column metaForDisplay={DataClass.TimeCounter.TargetDate} />

                    <Action caption="ویرایش" type="Link" pageName="/TimeCounter/Edit" columnName="id" />


                    <Action caption="حذف" type="function" targetFun={this.Delete} />




                </ProTable>
            </FromBasic>
        }
    }



}
export class AddTimeCounter extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.id = props.id;
        this.submit = this.submit.bind(this);
    }
    submit() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        let id = (cmd.id == undefined ? -1 : cmd.id);
        let o = h.GetPostData();
        h.Ajax('TimeCounter', (cmd.id == '-1' ? 'Insert' : 'Update'), { Model: o, id: id }, function (data) {
            if (data.status == 200) {
                h.MessageBox(data.message, FixedMessage.Result);
                h.GoBack();
            }
            else {
                h.Error(data.message, FixedMessage.Result);

            }
        });
    }
    componentDidMount() {
        let h = new Helper();
        if (this.id != -1) {
            h.Ajax('TimeCounter', 'Get', { id: this.id }, function (data) {
                h.SetDataBack(data);
            });


        }
    }
    render() {
        return <FromSubmit submitBev={this.submit}>
            <InputBox meta={DataClass.TimeCounter.Title} size='50%' />
            <InputBox meta={DataClass.TimeCounter.TargetDate} size='50%' />
            <InputBox meta={DataClass.TimeCounter.SubTitle} size='100%' />
            <InputTextBox customHelper={CustomHelper.Image} columnName="imageUrl" model="imageUrl" initvalue="imageUrl" caption="تصویر پس زمینه" size='100%' />


        </FromSubmit>

    }

}


function EditTimeCounter() {
    const queryS = useParams();
    return <AddTimeCounter id={queryS.id} />
}



export function ContextManagmentApp(props) {
    let routes = [<Route path="Categorys" element={<CategoryMgt />} />,
        <Route path="SlideShows" element={<SlideShowMgt />} />,
        <Route path="Layouts" element={<LayoutMgt />} />,
        <Route path="Persons" element={<PersonMgt />} />,
<Route path="Person/Add" element={<AddPerson id="-1" />} />,
                                           <Route path="Person/Edit/:id" element={<EditPerson />} />
        ,
                                                <Route path="Posts" element={<PostMgt />} />,
<Route path="Post/Add" element={<AddPost id="-1" />} />,
                                           <Route path="Post/Edit/:id" element={<EditPost />} />

        , <Route path="SpecPages" element={<AddSpecContext />} />,
        <Route path="Comments" element={<CommentMgt />} />,
        <Route path="Gallerys" element={<GalleryMgt />} />,
        <Route path="Messages" element={<MessageMgt />} />,
        <Route path="Links" element={<LinkWizard />} />,
        <Route path="Links/:linkPosition/:parentId" element={<Links />} />,
<Route path="Gallery/Add" element={<AddGallery id="-1" />} />,
                                           <Route path="Gallery/Edit/:id" element={<EditGallery />} />,
     <Route path="StaticPages" element={<StaticPageMgt />} />,
<Route path="StaticPage/Add" element={<AddStaticPage id="-1" />} />,
                                           <Route path="StaticPage/Edit/:id" element={<EditStaticPage />} />
        ,<Route path="TimeCounters" element={<TimeCounterMgt />} />,
<Route path="TimeCounter/Add" element={<AddTimeCounter id="-1" />} />,
                                           <Route path="TimeCounter/Edit/:id" element={<EditTimeCounter />} />



    ];








    return routes;
}